import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'reactstrap';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Popover } from 'antd';

import { parseHtml } from 'helpers';
import stylespopover from 'styles/Calendar.module.scss';
import { UnitIdContext } from 'pages/course/[slug]/unit/[unitId]';
const InputCounter = ({
  max,
  id,
  className,
  rows,
  isUseForm,
  propsValue,
  test,
  question,
  setQuestionArray,
  questionArray,
  handleOnchange,
  ...props
}) => {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);

  const containerRef = useRef(null);

  const explanation = test?.question?.config?.answers;
  const themeStatus = useSelector(getThemeColor);
  const isFullscreenMode = useContext(UnitIdContext);
  const Stylescal = styled.div`
    .textarea-counter-value {
      background-color: ${themeStatus} !important;
      color: #fff;
      padding: 1px 6px;
      font-size: 0.6rem;
      border-radius: 0 0 5px 5px;
      margin-right: 1rem;
    }
  `;
  // Pop over
  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    test?.userQuestion?.reAttempt &&
    !test?.userQuestion?.reAttempted &&
    test?.userQuestion?.status !== 'DRAFT'
      ? null
      : setValue(test?.userQuestion?.dataContent);
  }, [test?.userQuestion?.dataContent]);

  const handleAnswerValue = (answer) => {
    let array = [...questionArray];
    questionArray?.forEach((element, index) => {
      if (element._id === question?._id) {
        let obj = { ...element };
        obj.answerValue = answer;
        array.splice(index, 1, obj);
      }
      setQuestionArray(array);
    });
  };

  if (isUseForm) {
    return (
      <>
        <Input
          className={className}
          id={id}
          rows={rows}
          // maxLength={max}
          {...props}
          defaultValue={propsValue}
        />
        {max && (
          <Stylescal>
            <span
              className={classnames('textarea-counter-value float-right', {
                'bg-danger': propsValue?.length > max,
              })}
            >
              {`${propsValue?.length || 0}/${max}`}
            </span>
          </Stylescal>
        )}
      </>
    );
  }

  return (
    <>
      <div ref={containerRef}>
        <Popover
          {...(isFullscreenMode?.active
            ? { getPopupContainer: () => containerRef.current }
            : {})}
          placement={isFullscreenMode?.active ? 'left' : 'top'}
          content={
            <div
              className={`Popover-responsive  ${stylespopover.Popover_responsive}`}
              onClick={hide}
            >
              {parseHtml(test?.question?.explanation)}
            </div>
          }
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
        >
          {test?.question?.explanation?.length > 0 && (
            <img
              className="free-text-icon mt-1 float-right mb-1 position-relative"
              src={'/images/course/expand-view.png'}
              style={{
                height: 14,
                color: '#646871',
                cursor: 'pointer',
                zIndex: 20,
              }}
            />
          )}
        </Popover>
      </div>
      {test?.userQuestion?._id ? (
        <Input
          className={className}
          type="textarea"
          id={id}
          rows={rows}
          defaultValue={value}
          onChange={(e) => {
            setValue(e.target.value)
            handleOnchange?.(e.target.value)
          }}
          // maxLength={max}
          {...props}
        />
      ) : (
        <Input
          className={className}
          type="textarea"
          id={id}
          rows={rows}
          defaultValue={
            value
              ? value
              : test?.userQuestion?.reAttempt &&
                !test?.userQuestion?.reAttempted &&
                test?.userQuestion?.status !== 'DRAFT'
              ? null
              : test?.userQuestion?.dataContent
          }
          onChange={(e) => {
            setValue(e.target.value);
            handleOnchange?.(e.target.value)
            questionArray?.length && handleAnswerValue(e.target.value);
          }}
          // maxLength={max}
          {...props}
        />
      )}

      <Stylescal>
        <span
          className={classnames('textarea-counter-value float-right', {
            'bg-danger': value?.length > max,
          })}
        >
          {`${value?.length ? value?.length : 0}`}
          {/* {`${value?.length ? value?.length : 0}/${max}`} */}
        </span>
      </Stylescal>
    </>
  );
};

InputCounter.propTypes = {
  max: PropTypes.number.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  rows: PropTypes.string,
  isUseForm: PropTypes.bool,
  propsValue: PropTypes.string,
};

export default InputCounter;
